import { Configuration, StoresApi } from '@/api';
import SingleComboBox from '@/components/select/SingleComboBox';
import { Store, StoreAssociation } from '@/models/Store';
import { useAuth } from '@/modules/auth/contexts/AuthContext';

export interface PreviewStoreItem {
  id: string;
  name: string;
  store: Store;
}

interface ProductListPreviewStoreSelectProps {
  supplierId: string;
  value: PreviewStoreItem | null;
  onSelect: (item?: PreviewStoreItem | null) => void;
}

const ProductListPreviewStoreSelect = ({
  supplierId,
  value,
  onSelect,
}: ProductListPreviewStoreSelectProps) => {
  const storesApi = new StoresApi(new Configuration(useAuth));

  const findStores = async (query = ''): Promise<PreviewStoreItem[]> => {
    const response = await storesApi.findStores(
      query,
      { supplierId, supplierStoreStatus: 'ACTIVE' },
      0,
      10,
      [StoreAssociation.RETAILER, StoreAssociation.ORGANIZATION],
    );
    return response.items.map((store) => {
      const retailer = store.retailer?.organization?.name ?? store.retailer?.name;
      const name = store.code ? `${store.name} (${store.code})` : store.name;
      return { id: store.id, name: retailer ? `${name} — ${retailer}` : name, store };
    });
  };

  return (
    <SingleComboBox<PreviewStoreItem>
      name="preview-store"
      label="Store"
      placeholder="Search by store name…"
      value={value}
      onSelect={onSelect}
      queryFn={findStores}
      queryKey={['store', 'portfolioPreview', supplierId, 'activeSupplierRelationship']}
    />
  );
};

export default ProductListPreviewStoreSelect;
